import { render, staticRenderFns } from "./manualback.vue?vue&type=template&id=6bfe1238"
import script from "./manualback.vue?vue&type=script&lang=js"
export * from "./manualback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports